export class SocialMedia {
  public type: string;
  public url: string;

  constructor(data: Partial<SocialMedia> = {}) {
    this.type = data?.type ?? '';
    this.url = data?.url ?? '';
  }

  public static createFromApi(data: Partial<SocialMedia> = {}): SocialMedia {
    return new SocialMedia(data);
  }

  public processForApi(): Record<string, any> {
    return {
      type: this.type,
      url: this.url,
    };
  }
}
